export class DropNode {
  public constructor(public isShown: boolean = false) {}

  public show() {
    this.isShown = true;
  }

  public hide() {
    this.isShown = false;
  }
}
